import { render } from "./app-store-modal.vue?vue&type=template&id=319d624f"
import script from "./app-store-modal.vue?vue&type=script&lang=js"
export * from "./app-store-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__